import api from './api';
import { Investor, Administrator, CommercialManager, InvestorMetrics } from '../types/User';

// Investor Service
export const investorService = {
  getAll: () => api.get<Investor[]>('/investors'),
  getById: (id: string) => api.get<Investor>(`/investors/${id}`),
  create: (data: Investor) => api.post<Investor>('/investors', data),
  update: (id: string, data: Investor) => api.put<Investor>(`/investors/${id}`, data),
  delete: (id: string) => api.delete(`/investors/${id}`),
  getMetrics: (id: string) => api.get<InvestorMetrics>(`/investors/${id}/metrics`),
};

// Administrator Service
export const administratorService = {
  getAll: () => api.get<Administrator[]>('/administrators'),
  getById: (id: string) => api.get<Administrator>(`/administrators/${id}`),
  create: (data: Administrator) => api.post<Administrator>('/administrators', data),
  update: (id: string, data: Administrator) => api.put<Administrator>(`/administrators/${id}`, data),
  delete: (id: string) => api.delete(`/administrators/${id}`),
};

// Commercial Manager Service
export const commercialManagerService = {
  getAll: () => api.get<CommercialManager[]>('/commercial-managers'),
  getById: (id: string) => api.get<CommercialManager>(`/commercial-managers/${id}`),
  create: (data: CommercialManager) => api.post<CommercialManager>('/commercial-managers', data),
  update: (id: string, data: CommercialManager) => api.put<CommercialManager>(`/commercial-managers/${id}`, data),
  delete: (id: string) => api.delete(`/commercial-managers/${id}`),
};
